export const m = {
    // 顶部参数
    searchTxt: 'Please Enter Keywords To Find',
    welcome: 'Welcome To The Official Website Of China Hualong International Construction Corporation',
    email: 'Corporate Email',
    chinese: 'Cn',
    // 底部参数
    footerLeft: `<a href="/">Home</a><span>|</span>
    <a href="/joinUs">Join Us</a><span>|</span>
    <a href="/contact">Contact Us</a><span>|</span>
    <a href="/">Legal Statement</a>            
    <p> 
      <a href="/">China Hualong International Construction Corporation</a> 
      Copyright  <a href="https://beian.miit.gov.cn" target="_blank">Beijing ICP No. 20017936</a>
    </p>`,

    // 联络我们页面
    contact: 'Contact Us',
    contactWay: 'Contact Information',
    contactExplain: '',
    contactInfo: `
    <h3></h3>
    <p>Tel：010-56540571</p>
    <p>Fax：010-56540571</p>
    <p>E-mail：sinoron@sinoron.com.cn</p>
    <p>Add：4M,Tower2,Hanwei Int.Square Phase2,Fengtai District,Beijing</p>`,

    // 加入我们页面
    joinUs: 'Join Us',

    //企业文化页面
    culture: 'Corporate Culture',
    cultureIdea: 'Business philosophy',
    cultureIdeaInfo: 'Create with ingenuity and keep improving',
    mission: 'Enterprise mission',
    missionInfo: 'Honest operation, excellent business, satisfactory service and building the future together',
    vision: 'Corporate vision',
    visionInfo: 'Integrity, preciseness, self-improvement and development',
    value: 'Enterprise core value',
    valueInfo: 'Dedication, responsibility, refinement and win-win situation',
    target: 'Build a world-class engineering service platform',

    //业务领域
    business: 'Business Fields',

    //新闻列表
    topNews: 'Recommendations',

    //新闻详情页
    topTitle: 'Last',
    bottomTitle: 'Next',
    none: 'NONE',

    // 搜索页面
    search: 'Search',



}